var map = {
	"./amex.png": 944,
	"./diners.png": 945,
	"./discover.png": 946,
	"./jcb.png": 947,
	"./maestro.png": 1169,
	"./mastercard.png": 948,
	"./stripe.png": 949,
	"./union.png": 950,
	"./unknown.png": 623,
	"./visa.png": 951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1168;